import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button, Label, TabBar, TabItem } from '../components';
import cn from 'classnames';
import styles from './LandscapeBaseEditTemplate.module.css';

interface LandscapeEditProjectsAddProjectTemplateProps {
  children: React.ReactNode;
}

const LandscapeEditProjectsAddProjectTemplate: React.FC<
  LandscapeEditProjectsAddProjectTemplateProps
> = ({ children }) => {
  const navigate = useNavigate();
  const { id, projectId } = useParams();
  const location = useLocation();

  const getPrimaryTabRoute = (path: string) => {
    const segments = path.split('/');
    return segments.slice(0, 8).join('/');
  };

  const primaryTabRoute = getPrimaryTabRoute(location.pathname);
  return (
    <div>
      <div className={cn(styles.heading)}>
        <Label content={'Create Project'} size="lg" />
        <Button
          className={styles.buttonLink}
          onClick={() => navigate('/landscapes')}
          variant="link"
        >
          Go back to overview
        </Button>
      </div>
      <TabBar
        onSelect={(id: string | null) => {
          if (id) {
            navigate(id);
          }
        }}
        defaultSelected={primaryTabRoute}
      >
        <TabItem
          title="Basic information"
          id={`/landscapes/edit/${id}/projects/add-project/${projectId}/basic-information`}
        />
        <TabItem
          title="General Information"
          id={`/landscapes/edit/${id}/projects/add-project/${projectId}/general-information`}
        />
        <TabItem
          title="Impact"
          id={`/landscapes/edit/${id}/projects/add-project/${projectId}/impact`}
        />
        <TabItem
          title="Supporters"
          id={`/landscapes/edit/${id}/projects/add-project/${projectId}/supporters`}
        />
        <TabItem
          title="Documents"
          id={`/landscapes/edit/${id}/projects/add-project/${projectId}/documents`}
        />
        <TabItem
          title="Contact Information"
          id={`/landscapes/edit/${id}/projects/add-project/${projectId}/contact-information`}
        />
      </TabBar>
      <main>{children}</main>
    </div>
  );
};

export default LandscapeEditProjectsAddProjectTemplate;
